import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {NbAuthComponent} from "@nebular/auth";
import {DashboardlayoutComponent} from "@layout/dashboardlayout/dashboardlayout.component";
import {NbLayoutComponent} from "@nebular/theme";
import {
  LoanApplicationBorrowerLayoutComponent
} from "@layout/loan-application-borrower-layout/loan-application-borrower-layout.component";
import {QuickquoteLayoutComponent} from "@layout/quickquote-layout/quickquote-layout.component";


export const routes: Routes = [
  {
    path: '',
    redirectTo: '/auth',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    component : NbAuthComponent,
    loadChildren: () => import('./modules/auth/auth/auth.module')
      .then(m => m.AuthModule),
  },
  {
    path: 'dashboard',
    component : DashboardlayoutComponent,
    loadChildren: () => import('./modules/dashboard/dashboard.module')
      .then(m => m.DashboardModule),
  },
  {
    path: "loan-application",
    component : DashboardlayoutComponent,
    children: [
      {
        path: "",

        loadChildren: () =>
          import("./modules/loan-application/loan-application.module").
          then(
            m => m.LoanApplicationModule)
      }
    ]
  },
  {
    path: "loan-application-borrower",
    component : LoanApplicationBorrowerLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./modules/loan-application-borrower/loan-application-borrower.module").
          then(
            m => m.LoanApplicationBorrowerModule)
      }
    ]
  },
  {
    path: "settings",
    component : DashboardlayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./modules/settings/settings.module").
          then(
            m => m.SettingsModule)
      }
    ]
  },
  {
    path:"contacts",
    component:DashboardlayoutComponent,
    children:[
      {
        path:"",
        loadChildren:()=>
          import("./modules/contacts/contacts.module").then(m => m.ContactsModule)
      }
    ]
  },
  {
    path:"ratequote",
    component:QuickquoteLayoutComponent,
     children:[
      {
        path:"",
        loadChildren:()=>
          import("./modules/ratequote/ratequote.module").then(m => m.RatequoteModule)
      }
    ]
  }

];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
